import React from 'react'
import AddCostCenter from './AddCostCenter'
import CostCenters from './CostCenterListPage'
import EditCostCenter from './EditCostCenter'

// const CostCentercrumb = ({ match }) => <>{`Users-${match.params.id}`}</>;

const costCenterRoutes = [
  {
    breadcrumb: 'CostCenters',
    path: '',
    element: <CostCenters />,
    children: [],
  },
  {
    breadcrumb: 'CostCenters',
    path: 'create',
    element: <AddCostCenter />,
  },
  {
    breadcrumb: 'Edit CostCenters',
    path: ':id',
    element: <EditCostCenter />,
  },
]

export default costCenterRoutes
